<template>
  <div class="sweepCodeBinding">
    <img src="../../assets/images/updataFile/testBoxIcon.png" class="icon" />
    <div class="title">条码号贴在样本采集试管上扫码绑定信息</div>
    <div class="describe">条码号一经绑定，不可更改和再次绑定</div>
    <div class="sweepCodeBtnBox" @click="scanQRCode">
      <img src="../../assets/images/updataFile/sweepCodeIcon.png" />
      <div class="txt">扫一扫</div>
      <div class="txt">条码号</div>
    </div>
    <div @click="goManualBinding()" class="goManualBinding">
      手动绑定
      <img src="../../assets/images/updataFile/arrow-right-icon.png" />
    </div>
    <div @click="goBarCodeScanningGunBinding()" class="goManualBinding">
      扫码枪绑定
      <img src="../../assets/images/updataFile/arrow-right-icon.png" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    if (!localStorage.getItem("systemUserInfo")) {
      localStorage.setItem("redirect", location.hash.slice(1));
      this.$router.replace({
        name: "nurseLogin",
      });
    }
    if (!this.$store.state.wxConfigFlag) this.$wxConfig("1263309689931636737");
  },
  methods: {
    goManualBinding() {
      this.$router.push({
        name: "nurseManualBinding",
      });
    },
    goBarCodeScanningGunBinding() {
      this.$router.push({
        name: "barCodeScanningGunBinding",
      });
    },

    /**
     * 在微信浏览器中打开微信扫码
     */
    scanQRCode() {
      if (this.$isWeixin()) {
        this.wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: (res) => {
            let arr = res.resultStr.split(",");
            let barCode = "";
            if (arr.length == 1) barCode = arr[0];
            else barCode = arr[1];

            this.$nurseBindBox(barCode);
          },
        });
      } else {
        this.$toots("请在微信内置浏览器打开扫码");
      }
    },
  },
};
</script>

<style lang='less' scoped>
.sweepCodeBinding {
  text-align: center;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding-top: 50px;
  .icon {
    width: 750px;
    height: 426px;
    margin: 0 auto;
  }
  .title {
    font-size: 36px;
    line-height: 54px;
    margin: 0 auto;
    margin-top: 20px;
    width: 478px;
    font-weight: 700;
  }
  .describe {
    margin-top: 20px;
    font-size: 26px;
    color: #999999;
  }
  .sweepCodeBtnBox {
    width: 250px;
    height: 250px;
    margin: 0 auto;
    margin-top: 100px;
    border-radius: 250px;
    background: #1968a8;
    color: #fff;
    font-size: 30px;
    img {
      width: 63px;
      height: 65px;
      margin-top: 50px;
    }
  }
  .goManualBinding {
    margin-top: 40px;
    font-size: 26px;
    color: #999;
    // padding-bottom: 50px;
    margin-left: 20px;
    img {
      width: 14px;
      height: 24px;
      margin-left: 10px;
      vertical-align: middle;
      padding-bottom: 6px;
    }
  }
}
</style>
